import { motion } from "framer-motion";
import { Globe, Server, Link2, ShieldCheck, MailQuestion, MapPin, Smartphone, Settings, RefreshCw } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const ITEMS = [
  { icon: Globe, title: "Website", desc: "Professioneller Webauftritt, individuell passend zu Ihrem Unternehmen." },
  { icon: Link2, title: "Domain", desc: "Wir kümmern uns um die Domain im Rahmen Ihres Website-Services." },
  { icon: Server, title: "Hosting", desc: "Kein eigener Hostingvertrag notwendig – wir stellen alles bereit." },
  { icon: ShieldCheck, title: "SSL / HTTPS", desc: "Sichere, verschlüsselte Verbindung für Ihre Besucher." },
  { icon: MailQuestion, title: "Kontaktformular", desc: "Interessenten nehmen direkt über die Website Kontakt auf." },
  { icon: MapPin, title: "Google Maps", desc: "Ihr Unternehmensstandort direkt auf der Website eingebunden." },
  { icon: Smartphone, title: "Smartphone-Optimierung", desc: "Perfekte Darstellung auf Handy, Tablet und Desktop." },
  { icon: Settings, title: "Technik & Wartung", desc: "Wir kümmern uns um die technische Bereitstellung und Pflege." },
  { icon: RefreshCw, title: "Änderungen", desc: "Je nach Paket übernehmen wir laufende Aktualisierungen für Sie." },
];

export default function WebsiteService() {
  return (
    <section id="leistungen" className="relative py-14 lg:py-20 border-t border-white/10 bg-[#0b0806]/70" data-testid="website-service">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FF3B00]" /> Der Website-Service
            </Reveal>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase">
              <MaskLineInView>Alles drin.</MaskLineInView>
              <MaskLineInView delay={0.1}>Alles aus einer Hand.</MaskLineInView>
            </h2>
          </div>
          <Reveal delay={0.2} className="max-w-sm text-neutral-400 text-base leading-relaxed">
            Sie müssen sich um nichts kümmern. Von der Website über Domain und Hosting bis zur
            laufenden Betreuung – wir übernehmen das für Sie.
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
              className="group bg-[#100b07] p-7 lg:p-8 hover:bg-[#0F0F0F] transition-colors duration-300"
              data-testid={`service-item-${i}`}
            >
              <div className="mb-6 inline-flex items-center justify-center h-12 w-12 border border-white/10 group-hover:border-[#FF3B00] transition-colors">
                <it.icon strokeWidth={1.4} className="h-5 w-5 text-[#FF3B00]" />
              </div>
              <h3 className="font-display text-xl text-white mb-2">{it.title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
